// =============================================================
// WM Configurator V1 — Vanilla JS state machine + render
// =============================================================
(function () {
  'use strict';

  var ROOT = document.querySelector('[data-wm-configurator]');
  if (!ROOT) return;

  // -----------------------------------------------------------
  // CONSTANTS
  // -----------------------------------------------------------
  var UNIT_PRICE = { 12: 33, 13: 36, 14: 39, 15: 39, 16: 45, 17: 59 };
  var DISCOUNT = { 1: 0, 2: 0.10, 3: 0.15, 4: 0.25 };
  var SLOT_LABELS = ['AV.G', 'AV.D', 'AR.G', 'AR.D'];
  var SLOT_FULL = { 'AV.G': 'roue avant gauche', 'AV.D': 'roue avant droite', 'AR.G': 'roue arrière gauche', 'AR.D': 'roue arrière droite' };

  var WM_DESIGNS = [
    { id: 'smiley', name: 'Y2K Smile', cat: 'Y2K', glyph: ':)', fg: '#FFEE00', bg: '#1a0a2e', glow: true, glyphScale: 0.55 },
    { id: 'flame', name: 'Hot Fire', cat: 'Y2K', glyph: '🔥', fg: '#FF3CAC', bg: '#1a0a14', glow: false, glyphScale: 0.55 },
    { id: 'jdm', name: 'JDM Kanji', cat: 'JDM', glyph: '走', fg: '#00F0FF', bg: '#0a1a2a', glow: true, glyphScale: 0.55 },
    { id: 'drift', name: 'Drift King', cat: 'JDM', glyph: 'DK', fg: '#00F0FF', bg: '#0a0a1a', glow: true, glyphScale: 0.46 },
    { id: 'anime1', name: 'Sakura', cat: 'Anime', glyph: '✿', fg: '#FF3CAC', bg: '#1a0a1a', glow: true, glyphScale: 0.55 },
    { id: 'anime2', name: 'Tokyo Night', cat: 'Anime', glyph: '東京', fg: '#00F0FF', bg: '#0a0a1a', glow: true, glyphScale: 0.32 },
    { id: 'star', name: 'Neon Star', cat: 'Y2K', glyph: '★', fg: '#FFEE00', bg: '#0a0a1a', glow: true, glyphScale: 0.55 },
    { id: 'heart', name: 'Cyber Heart', cat: 'Y2K', glyph: '♥', fg: '#FF3CAC', bg: '#1a0a14', glow: true, glyphScale: 0.55 },
    { id: 'skull', name: 'Skull Crew', cat: 'Sport', glyph: '☠', fg: '#FFFFFF', bg: '#0a0a0a', glow: false, glyphScale: 0.52 },
    { id: 'lighting', name: 'Boltz', cat: 'Sport', glyph: '⚡', fg: '#FFEE00', bg: '#0a0a1a', glow: true, glyphScale: 0.55 },
    { id: 'fr', name: 'France Flag', cat: 'Drapeaux', glyph: 'FR', fg: '#FFFFFF', bg: '#0a0a2a', glow: false, glyphScale: 0.46 },
    { id: 'jp', name: 'JP Rising', cat: 'Drapeaux', glyph: '日', fg: '#FF3CAC', bg: '#0a0a0a', glow: true, glyphScale: 0.55 },
    { id: 'wm', name: 'WM Logo', cat: 'Lettering', glyph: 'WM', fg: '#00F0FF', bg: '#0a0a14', glow: true, glyphScale: 0.42 },
    { id: 'gg', name: 'GG / EZ', cat: 'Lettering', glyph: 'GG', fg: '#FF3CAC', bg: '#0a0a1a', glow: true, glyphScale: 0.46 },
    { id: 'eye', name: 'Cyber Eye', cat: 'Anime', glyph: '◉', fg: '#00F0FF', bg: '#0a0a1a', glow: true, glyphScale: 0.55 },
    { id: 'arrow', name: 'Forward', cat: 'Sport', glyph: '➤', fg: '#FFEE00', bg: '#0a0a0a', glow: true, glyphScale: 0.5 }
  ];

  var COMMUNITY_DESIGNS = [
    { id: 'c1', author: 'Léa M.', likes: 234, hubcap: { glyph: '🌸', fg: '#FF3CAC', bg: '#1a0a2e', glow: true, glyphScale: 0.55 } },
    { id: 'c2', author: 'Karim B.', likes: 189, hubcap: { glyph: 'KB', fg: '#00F0FF', bg: '#0a0a14', glow: true, glyphScale: 0.42 } },
    { id: 'c3', author: 'Maxime', likes: 156, hubcap: { glyph: '⚡', fg: '#FFEE00', bg: '#0a0a0a', glow: true, glyphScale: 0.55 } },
    { id: 'c4', author: 'Anaïs', likes: 142, hubcap: { glyph: '♥', fg: '#FF3CAC', bg: '#1a0a14', glow: true, glyphScale: 0.55 } },
    { id: 'c5', author: 'Théo', likes: 128, hubcap: { glyph: '走', fg: '#00F0FF', bg: '#0a1a2a', glow: true, glyphScale: 0.55 } },
    { id: 'c6', author: 'Sofia', likes: 119, hubcap: { glyph: '★', fg: '#FFEE00', bg: '#0a0a1a', glow: true, glyphScale: 0.55 } },
    { id: 'c7', author: 'Hugo', likes: 98, hubcap: { glyph: '☠', fg: '#FFFFFF', bg: '#0a0a0a', glow: false, glyphScale: 0.52 } },
    { id: 'c8', author: 'Zoé', likes: 87, hubcap: { glyph: '◉', fg: '#00F0FF', bg: '#0a0a1a', glow: true, glyphScale: 0.55 } }
  ];

  // Variants Shopify (size → variant_id) parsed from data attribute
  var VARIANTS = (function () {
    try { return JSON.parse(ROOT.dataset.variants || '[]'); } catch (e) { return []; }
  })();
  function variantIdForSize(sizeInches) {
    var label = sizeInches + 'inch';
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      var match = false;
      if (v.title && v.title.indexOf(label) >= 0) match = true;
      if (v.option1 && (v.option1 == sizeInches || v.option1 == sizeInches + '"' || v.option1 == label)) match = true;
      if (match) return v.id;
    }
    return VARIANTS[0] ? VARIANTS[0].id : null;
  }

  // -----------------------------------------------------------
  // STATE
  // -----------------------------------------------------------
  function makeSlot(presetId) {
    return {
      mode: 'preset',
      presetId: presetId || 'jdm',
      communityId: null,
      image: null,        // dataURL ou blob URL
      imgZoom: 1.0,
      imgRotate: 0,
      imgX: 0,
      imgY: 0
    };
  }

  function uuidv4() {
    return 'wm-' + Date.now().toString(36) + '-' + Math.random().toString(36).substring(2, 10);
  }

  window.WMConfig = {
    mix: 'same',
    activeSlot: 0,
    slots: [makeSlot('jdm'), makeSlot('jdm'), makeSlot('jdm'), makeSlot('jdm')],
    size: 15,
    units: 4,
    setId: uuidv4()
  };

  // -----------------------------------------------------------
  // HELPERS
  // -----------------------------------------------------------
  function $(sel, root) { return (root || ROOT).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || ROOT).querySelectorAll(sel)); }
  function getDesign(id) { for (var i = 0; i < WM_DESIGNS.length; i++) if (WM_DESIGNS[i].id === id) return WM_DESIGNS[i]; return WM_DESIGNS[0]; }
  function getCommunity(id) { for (var i = 0; i < COMMUNITY_DESIGNS.length; i++) if (COMMUNITY_DESIGNS[i].id === id) return COMMUNITY_DESIGNS[i]; return null; }
  function slotToDesign(slot) {
    if (slot.mode === 'preset') return getDesign(slot.presetId);
    if (slot.mode === 'community') {
      var c = getCommunity(slot.communityId);
      return c ? Object.assign({ id: c.id, name: 'par ' + c.author, cat: 'Communauté' }, c.hubcap) : getDesign('jdm');
    }
    if (slot.mode === 'upload' && slot.image) {
      return { id: 'custom', name: 'Mon image', cat: 'Custom', isImage: true, image: slot.image, glow: false, fg: '#fff', bg: '#0F0F0F' };
    }
    return getDesign('jdm');
  }
  function slotLabel(slot) {
    var d = slotToDesign(slot);
    return d.name;
  }
  function applyToAll(patch) {
    for (var i = 0; i < 4; i++) Object.assign(window.WMConfig.slots[i], patch);
  }
  function patchSlot(patch) {
    var s = window.WMConfig;
    if (s.mix === 'same') applyToAll(patch);
    else Object.assign(s.slots[s.activeSlot], patch);
  }
  function fmtPrice(n) {
    return n + '€';
  }
  function computePricing() {
    var s = window.WMConfig;
    var unit = 0, lbl = s.size + "inch", i, v;
    for (i = 0; i < VARIANTS.length; i++) {
      v = VARIANTS[i];
      if ((v.title && String(v.title).indexOf(lbl) >= 0) || (v.option1 && (v.option1 == s.size || v.option1 == lbl))) {
        unit = (parseFloat(v.price) || 0) / 100;
        break;
      }
    }
    if (!unit) { unit = ({ 12: 33, 13: 36, 14: 39, 15: 39, 16: 45, 17: 59 })[s.size] || 0; }
    var rate = DISCOUNT[s.units] || 0;
    var total = Math.round(unit * s.units * 100) / 100;
    var reference = rate > 0 ? Math.round(total / (1 - rate) * 100) / 100 : total;
    var savings = Math.round((reference - total) * 100) / 100;
    return { unit: unit, subtotal: reference, total: total, savings: savings, discount: rate };
  }

  // -----------------------------------------------------------
  // RENDER : HUBCAP CSS PUR (réutilisable pour preview + minis)
  // -----------------------------------------------------------
  function renderHubcap(target, design, size) {
    if (!target) return;
    target.dataset.mode = design.isImage ? 'upload' : 'preset';
    target.style.setProperty('--design-bg', design.bg);
    target.style.setProperty('--design-fg', design.fg);
    target.style.setProperty('--design-glow-px', design.glow ? Math.round(size * 0.08) + 'px' : '0px');

    // Glyph
    var glyphEl = target.querySelector('.wm-hub-glyph');
    if (glyphEl) {
      glyphEl.textContent = design.glyph || '';
      glyphEl.style.fontSize = Math.round(size * (design.glyphScale || 0.42)) + 'px';
    }

    // Image (mode upload)
    var imgWrap = target.querySelector('.wm-hub-image');
    if (imgWrap) {
      if (design.isImage && design.image) {
        imgWrap.innerHTML = '<img src="' + design.image.src + '" alt="">';
        var img = imgWrap.querySelector('img');
        if (img && design.image.transform) {
          var t = design.image.transform;
          img.style.transform = 'translate(' + (t.x || 0) + 'px, ' + (t.y || 0) + 'px) scale(' + (t.zoom || 1) + ') rotate(' + (t.rot || 0) + 'deg)';
        }
      } else {
        imgWrap.innerHTML = '';
      }
    }
  }

  // -----------------------------------------------------------
  // RENDER : Preview (gros hubcap central + badges)
  // -----------------------------------------------------------
  function renderPreview() {
    var s = window.WMConfig;
    var slot = s.slots[s.activeSlot];
    var design = slotToDesign(slot);
    if (slot.mode === 'upload' && slot.image) {
      design = Object.assign({}, design, {
        image: { src: slot.image, transform: { x: slot.imgX, y: slot.imgY, zoom: slot.imgZoom, rot: slot.imgRotate } }
      });
    }
    var hub = $('[data-wm-target="hubcap-main"]');
    renderHubcap(hub, design, 460);

    var sizeBadge = $('[data-wm-target="size-badge"]');
    if (sizeBadge) sizeBadge.textContent = s.size + '" · ⌀ ' + Math.round(s.size * 2.54) + 'cm';

    var designBadge = $('[data-wm-target="design-badge"]');
    if (designBadge) {
      if (s.mix === 'mix') designBadge.textContent = SLOT_LABELS[s.activeSlot] + ' · ' + design.name;
      else designBadge.textContent = design.name;
    }
  }

  // -----------------------------------------------------------
  // RENDER : Mini-set sous preview
  // -----------------------------------------------------------
  function renderMiniSet() {
    var s = window.WMConfig;
    var slots = $$('[data-wm-target="mini-set"] .wm-mini-set__slot');
    slots.forEach(function (btn, i) {
      var design = slotToDesign(s.slots[i]);
      if (s.slots[i].mode === 'upload' && s.slots[i].image) {
        design = Object.assign({}, design, {
          image: { src: s.slots[i].image, transform: { x: s.slots[i].imgX, y: s.slots[i].imgY, zoom: s.slots[i].imgZoom, rot: s.slots[i].imgRotate } }
        });
      }
      var hub = btn.querySelector('.wm-mini-hubcap');
      renderHubcap(hub, design, 36);
      var lbl = btn.querySelector('.wm-mini-set__label');
      if (lbl) lbl.textContent = s.mix === 'mix' ? SLOT_LABELS[i] : '';
      btn.classList.toggle('is-active', s.mix === 'mix' && s.activeSlot === i);
      btn.disabled = s.mix === 'same';
    });
    var hint = $('[data-wm-target="mini-hint"]');
    if (hint) hint.textContent = s.mix === 'same' ? '· SUR TES 4 ROUES' : '· CLIQUE POUR ÉDITER';
  }

  // -----------------------------------------------------------
  // RENDER : Slot picker (4 boutons AV.G/AV.D/AR.G/AR.D)
  // -----------------------------------------------------------
  function renderSlotPicker() {
    var s = window.WMConfig;
    var picker = $('[data-wm-target="slot-picker"]');
    if (!picker) return;
    picker.hidden = s.mix !== 'mix';
    var label = $('[data-wm-target="active-slot-label"]');
    if (label) label.textContent = 'roue ' + SLOT_LABELS[s.activeSlot];
    var btns = $$('.wm-slot-picker__btn', picker);
    btns.forEach(function (btn, i) {
      var design = slotToDesign(s.slots[i]);
      var hub = btn.querySelector('.wm-mini-hubcap');
      renderHubcap(hub, design, 32);
      var span = btn.querySelector('span');
      if (span) span.textContent = SLOT_LABELS[i];
      btn.classList.toggle('is-active', s.activeSlot === i);
    });
  }

  // -----------------------------------------------------------
  // RENDER : Mix toggle + tabs mode
  // -----------------------------------------------------------
  function renderMixToggle() {
    var s = window.WMConfig;
    $$('[data-wm-action="set-mix"]').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.mix === s.mix);
    });
  }
  function renderTabs() {
    var s = window.WMConfig;
    var slot = s.slots[s.activeSlot];
    $$('.wm-tab').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.mode === slot.mode);
    });
  }

  // -----------------------------------------------------------
  // RENDER : Tab content selon mode
  // -----------------------------------------------------------
  function renderTabContent() {
    var s = window.WMConfig;
    var slot = s.slots[s.activeSlot];
    var container = $('[data-wm-target="tab-content"]');
    if (!container) return;
    if (slot.mode === 'preset') container.innerHTML = renderPresetGrid(slot);
    else if (slot.mode === 'upload') container.innerHTML = renderUploadEditor(slot);
    else if (slot.mode === 'community') container.innerHTML = renderCommunityGrid(slot);
    // Re-render mini-hubcaps inside tab content
    $$('.wm-mini-hubcap[data-design-id]', container).forEach(function (el) {
      var d = getDesign(el.dataset.designId) || (function () {
        var c = getCommunity(el.dataset.designId);
        return c ? Object.assign({ id: c.id, name: c.author }, c.hubcap) : null;
      })();
      if (d) renderHubcap(el, d, 60);
    });
  }
  function renderPresetGrid(slot) {
    var sub = '<p class="wm-tab__sub">' + (window.WMConfig.mix === 'mix' ? 'DESIGN POUR ' + SLOT_LABELS[window.WMConfig.activeSlot] : '02 · CHOISIS UN DESIGN') + '</p>';
    var html = sub + '<div class="wm-preset-grid">';
    WM_DESIGNS.slice(0, 12).forEach(function (d) {
      var active = slot.mode === 'preset' && slot.presetId === d.id;
      html += '<button class="wm-preset-btn' + (active ? ' is-active' : '') + '" data-wm-action="set-preset" data-preset-id="' + d.id + '" type="button">';
      html += '<div class="wm-hub wm-mini-hubcap" data-design-id="' + d.id + '">';
      html += '<div class="wm-hub-rim"></div><div class="wm-hub-spoke s0"></div><div class="wm-hub-spoke s60"></div><div class="wm-hub-spoke s120"></div>';
      html += '<div class="wm-hub-glyph"></div><div class="wm-hub-hub"></div>';
      html += '</div>';
      html += '<span class="wm-preset-name">' + d.name + '</span>';
      html += '</button>';
    });
    html += '</div>';
    html += '<a href="/pages/collection" class="wm-link-pink">▸ Voir les 16 designs ↗</a>';
    return html;
  }
  function renderUploadEditor(slot) {
    var sub = '<p class="wm-tab__sub">' + (window.WMConfig.mix === 'mix' ? 'IMAGE POUR ' + SLOT_LABELS[window.WMConfig.activeSlot] : '02 · TON IMAGE') + '</p>';
    var html = sub;
    if (!slot.image) {
      html += '<div class="wm-upload-zone" data-wm-action="upload-trigger" role="button" tabindex="0">';
      html += '<input type="file" accept="image/*" hidden data-wm-target="upload-input">';
      html += '<div class="wm-upload-icon">↑</div>';
      html += '<div class="wm-upload-title">Glisse ton image ou <strong>parcourir</strong></div>';
      html += '<div class="wm-upload-hint">▸ JPG, PNG, SVG · idéalement &gt; 1200px pour un rendu net</div>';
      html += '</div>';
    } else {
      html += '<div class="wm-upload-edit">';
      html += '<div class="wm-upload-thumb"><img src="' + slot.image + '" alt="" style="transform: translate(' + slot.imgX + 'px,' + slot.imgY + 'px) scale(' + slot.imgZoom + ') rotate(' + slot.imgRotate + 'deg);"></div>';
      html += '<div class="wm-sliders">';
      html += sliderHTML('Zoom', 'imgZoom', slot.imgZoom, 0.5, 3, 0.05, '×');
      html += sliderHTML('Rotation', 'imgRotate', slot.imgRotate, -180, 180, 1, '°');
      html += sliderHTML('Position X', 'imgX', slot.imgX, -100, 100, 1, 'px');
      html += sliderHTML('Position Y', 'imgY', slot.imgY, -100, 100, 1, 'px');
      html += '<div class="wm-upload-actions">';
      html += '<button class="wm-link-cyan" data-wm-action="upload-recenter" type="button">↺ Recentrer</button>';
      html += '<button class="wm-link-pink" data-wm-action="upload-remove" type="button">× Retirer</button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
    }
    return html;
  }
  function sliderHTML(label, key, val, min, max, step, suffix) {
    return '<label class="wm-slider"><span class="wm-slider__label">' + label + '</span>' +
      '<input type="range" min="' + min + '" max="' + max + '" step="' + step + '" value="' + val + '" data-wm-action="upload-slider" data-key="' + key + '">' +
      '<span class="wm-slider__val">' + (Math.round(val * 100) / 100) + suffix + '</span></label>';
  }
  function renderCommunityGrid(slot) {
    var sub = '<p class="wm-tab__sub">' + (window.WMConfig.mix === 'mix' ? 'GALERIE POUR ' + SLOT_LABELS[window.WMConfig.activeSlot] : '02 · DESIGNS DE LA COMMUNAUTÉ') + '</p>';
    var html = sub + '<div class="wm-community-grid">';
    COMMUNITY_DESIGNS.forEach(function (c) {
      var active = slot.mode === 'community' && slot.communityId === c.id;
      html += '<button class="wm-community-btn' + (active ? ' is-active' : '') + '" data-wm-action="set-community" data-community-id="' + c.id + '" type="button">';
      html += '<div class="wm-hub wm-mini-hubcap" data-design-id="' + c.id + '">';
      html += '<div class="wm-hub-rim"></div><div class="wm-hub-spoke s0"></div><div class="wm-hub-spoke s60"></div><div class="wm-hub-spoke s120"></div>';
      html += '<div class="wm-hub-glyph"></div><div class="wm-hub-hub"></div>';
      html += '</div>';
      html += '<span class="wm-community-name">' + c.author + '</span>';
      html += '<span class="wm-community-likes">♥ ' + c.likes + '</span>';
      html += '</button>';
    });
    html += '</div>';
    return html;
  }

  // -----------------------------------------------------------
  // RENDER : Size + Qty + CTA
  // -----------------------------------------------------------
  function renderSize() {
    var s = window.WMConfig;
    $$('.wm-size-btn').forEach(function (b) {
      b.classList.toggle('is-active', parseInt(b.dataset.size, 10) === s.size);
    });
  }
  function renderQty() {
    var s = window.WMConfig;
    $$('.wm-qty-btn').forEach(function (b) {
      var u = parseInt(b.dataset.units, 10);
      b.classList.toggle('is-active', u === s.units);
      var small = b.querySelector('small');
      if (small) {
        var d = DISCOUNT[u];
        small.textContent = d > 0 ? ('−' + Math.round(d * 100) + '%') : 'Plein tarif';
      }
    });
    var bar = $('[data-wm-target="qty-bar"]');
    if (bar) {
      bar.style.setProperty('--wm-fill', (s.units * 25) + '%');
      var hint = $('[data-wm-target="qty-hint"]');
      if (s.units === 4) {
        bar.classList.add('is-complete');
        if (hint) hint.innerHTML = '<strong>✓ SET COMPLET DÉBLOQUÉ · −25% APPLIQUÉ</strong>';
      } else {
        bar.classList.remove('is-complete');
        if (hint) hint.innerHTML = 'Plus que <strong>' + (4 - s.units) + '</strong> pour le set complet à <strong style="color:var(--wm-pink);">−25%</strong>.';
      }
    }
  }
  function renderCTA() {
    var s = window.WMConfig;
    var p = computePricing();
    var recap = $('[data-wm-target="cta-recap"]');
    if (recap) {
      var allSame = s.slots.every(function (sl, i, arr) { return slotToDesign(sl).id === slotToDesign(arr[0]).id; });
      var lbl = (s.mix === 'mix' && !allSame) ? 'Set mixte' : slotToDesign(s.slots[0]).name;
      recap.textContent = s.units + '× ' + lbl + ' · ' + s.size + '"';
    }
    var totalEl = $('[data-wm-target="cta-total"]');
    if (totalEl) totalEl.textContent = fmtPrice(p.total);
    var subEl = $('[data-wm-target="cta-subtotal"]');
    if (subEl) {
      if (p.discount > 0) { subEl.textContent = fmtPrice(p.subtotal); subEl.hidden = false; }
      else subEl.hidden = true;
    }
    var savEl = $('[data-wm-target="cta-savings"]');
    if (savEl) {
      if (p.savings > 0) { savEl.textContent = '−' + p.savings + '€'; savEl.hidden = false; }
      else savEl.hidden = true;
    }
    var btnPrice = $('[data-wm-target="cta-btn-price"]');
    if (btnPrice) btnPrice.textContent = fmtPrice(p.total);
    var variantInput = $('[data-wm-target="variant-id"]');
    if (variantInput) {
      var vid = variantIdForSize(s.size);
      if (vid) variantInput.value = vid;
    }
  }

  // -----------------------------------------------------------
  // RENDER ALL
  // -----------------------------------------------------------
  function renderAll() {
    renderMixToggle();
    renderSlotPicker();
    renderTabs();
    renderTabContent();
    renderPreview();
    renderMiniSet();
    renderSize();
    renderQty();
    renderCTA();
  }

  // -----------------------------------------------------------
  // ACTIONS (event delegation)
  // -----------------------------------------------------------
  ROOT.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wm-action]');
    if (!t) return;
    var action = t.dataset.wmAction;
    var s = window.WMConfig;

    if (action === 'set-mix') {
      e.preventDefault();
      s.mix = t.dataset.mix;
      if (s.mix === 'same') {
        // Replicate active slot to all
        var src = s.slots[s.activeSlot];
        applyToAll({ mode: src.mode, presetId: src.presetId, communityId: src.communityId, image: src.image, imgZoom: src.imgZoom, imgRotate: src.imgRotate, imgX: src.imgX, imgY: src.imgY });
      }
      renderAll();
    }
    else if (action === 'select-slot') {
      e.preventDefault();
      var idx = parseInt(t.dataset.slot, 10);
      if (s.mix === 'mix' && !isNaN(idx)) {
        s.activeSlot = idx;
        renderAll();
      }
    }
    else if (action === 'set-mode') {
      e.preventDefault();
      patchSlot({ mode: t.dataset.mode });
      renderAll();
    }
    else if (action === 'set-preset') {
      e.preventDefault();
      patchSlot({ mode: 'preset', presetId: t.dataset.presetId });
      renderAll();
    }
    else if (action === 'set-community') {
      e.preventDefault();
      patchSlot({ mode: 'community', communityId: t.dataset.communityId });
      renderAll();
    }
    else if (action === 'set-size') {
      e.preventDefault();
      s.size = parseInt(t.dataset.size, 10);
      renderSize(); renderPreview(); renderCTA();
    }
    else if (action === 'set-units') {
      e.preventDefault();
      s.units = parseInt(t.dataset.units, 10);
      renderQty(); renderCTA();
    }
    // upload-trigger: native label click handles file picker — no JS click needed (avoids double click bug)
    else if (action === 'upload-recenter') {
      e.preventDefault();
      patchSlot({ imgZoom: 1, imgRotate: 0, imgX: 0, imgY: 0 });
      renderAll();
    }
    else if (action === 'upload-remove') {
      e.preventDefault();
      patchSlot({ image: null, imgZoom: 1, imgRotate: 0, imgX: 0, imgY: 0 });
      renderAll();
    }
  });

  ROOT.addEventListener('change', function (e) {
    var t = e.target;
    if (t.dataset && t.dataset.wmTarget === 'upload-input' && t.files && t.files[0]) {
      var reader = new FileReader();
      reader.onload = function (ev) {
        patchSlot({ mode: 'upload', image: ev.target.result, imgZoom: 1, imgRotate: 0, imgX: 0, imgY: 0 });
        renderAll();
      };
      reader.readAsDataURL(t.files[0]);
    }
  });

  ROOT.addEventListener('input', function (e) {
    var t = e.target;
    if (t.dataset && t.dataset.wmAction === 'upload-slider') {
      var key = t.dataset.key;
      var val = parseFloat(t.value);
      var patch = {}; patch[key] = val;
      patchSlot(patch);
      // Targeted re-render: preview + mini-set + thumb only (avoid full DOM rebuild that would lose slider focus)
      renderPreview();
      renderMiniSet();
      // Update thumb transform live
      var thumb = $('.wm-upload-thumb img');
      if (thumb) {
        var s = window.WMConfig.slots[window.WMConfig.activeSlot];
        thumb.style.transform = 'translate(' + s.imgX + 'px,' + s.imgY + 'px) scale(' + s.imgZoom + ') rotate(' + s.imgRotate + 'deg)';
      }
      var lbl = t.parentNode.querySelector('.wm-slider__val');
      if (lbl) {
        var suffix = key === 'imgZoom' ? '×' : (key === 'imgRotate' ? '°' : 'px');
        lbl.textContent = (Math.round(val * 100) / 100) + suffix;
      }
    }
  });

  // -----------------------------------------------------------
  // FORM SUBMIT : Build 4 line items
  // -----------------------------------------------------------
  var form = $('[data-wm-target="cta"]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var s = window.WMConfig;
      var p = computePricing();
      var setId = s.setId;
      var vid = variantIdForSize(s.size);
      if (!vid) { alert('Erreur taille — recharge la page'); return; }
      // Build N line items (one per wheel up to s.units)
      var items = [];
      for (var i = 0; i < s.units; i++) {
        var slot = s.slots[s.mix === 'mix' ? i : 0];
        var design = slotToDesign(slot);
        var props = {
          'Slot': SLOT_LABELS[i],
          '_Mode': slot.mode,
          'Design': design.name,
          '_DesignId': design.id || slot.presetId || slot.communityId || 'unknown',
          'Size': s.size + '"',
          '_SetMode': s.mix,
          '_SetId': setId,
          '_ShippingCountry': (window.WMGeo && window.WMGeo.country) || '',
          '_ShippingRate': (window.WMGeo && window.WMGeo.rate) ? window.WMGeo.rate : ''
        };
        if (slot.mode === 'community') props['_CommunityAuthor'] = (getCommunity(slot.communityId) || {}).author || '';
        if (slot.mode === 'upload') {
          props['_ImgTransform'] = 'zoom:' + slot.imgZoom + ';rot:' + slot.imgRotate + ';x:' + slot.imgX + ';y:' + slot.imgY;
          // V1: no Files API upload — store base64 in property is too large. Just mark image presence.
          props['_HasCustomImage'] = '1';
        }
        items.push({ id: vid, quantity: 1, properties: props });
      }
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status >= 400) throw new Error(data.description || data.message);
          if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-success'); }
          // Visual feedback
          var orig = btn ? btn.innerHTML : '';
          if (btn) btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> AJOUTÉ ✓';
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: data.items ? data.items.length : items.length } }));
          setTimeout(function () {
            if (btn) { btn.disabled = false; btn.classList.remove('is-success'); btn.innerHTML = orig; }
            // Generate fresh setId for next add
            window.WMConfig.setId = uuidv4();
            // Open cart drawer if available
            if (window.location.pathname !== '/cart') window.location.href = '/cart';
          }, 1400);
        })
        .catch(function (err) {
          console.error('WMConfig add-to-cart error', err);
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
          alert('Erreur ajout au panier : ' + (err.message || 'inconnue'));
        });
    });
  }

  // -----------------------------------------------------------
  // INIT
  // -----------------------------------------------------------
  renderAll();
})();


// ===========================================================
// V1.5 — Upload réel vers Shopify Files via /cart/add multipart
// Override default fetch /cart/add.js for upload mode
// ===========================================================
(function(){
  var origSubmit = null;
  document.addEventListener('DOMContentLoaded', function(){
    var form = document.querySelector('[data-wm-target="cta"]');
    if (!form) return;
    
    form.addEventListener('submit', function(e){
      if (!window.WMConfig) return;
      var s = window.WMConfig;
      var hasUpload = s.slots.some(function(sl){ return sl.mode === 'upload' && sl.image; });
      if (!hasUpload) return; // let original JSON handler do its thing
      
      // INTERCEPT: do multipart upload instead
      e.preventDefault();
      e.stopImmediatePropagation();
      
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      
      // Find first upload input with a file
      var uploadInput = document.querySelector('[data-wm-target="upload-input"]');
      var file = uploadInput && uploadInput.files && uploadInput.files[0];
      if (!file && s.slots[0].image && s.slots[0].image.indexOf('data:') === 0) {
        // Recreate Blob from dataURL
        var bin = atob(s.slots[0].image.split(',')[1]);
        var arr = new Uint8Array(bin.length);
        for (var i=0; i<bin.length; i++) arr[i] = bin.charCodeAt(i);
        file = new Blob([arr], {type: s.slots[0].image.split(';')[0].split(':')[1] || 'image/png'});
        file.name = 'design-' + s.setId + '.png';
      }
      if (!file) { alert('Image upload introuvable. Re-sélectionne ton fichier.'); if (btn) { btn.disabled=false; btn.classList.remove('is-loading'); } return; }
      
      // For each slot in upload mode, POST one line item with the file
      var vid = (function(){
        for (var i=0; i<window.WMConfig.slots.length; i++) {}
        var label = s.size + 'inch';
        try {
          var variants = JSON.parse(document.querySelector('[data-wm-configurator]').dataset.variants || '[]');
          for (var i=0; i<variants.length; i++) {
            if (variants[i].title && variants[i].title.indexOf(label) >= 0) return variants[i].id;
            if (variants[i].option1 == label) return variants[i].id;
          }
          return variants[0] ? variants[0].id : null;
        } catch(e) { return null; }
      })();
      if (!vid) { alert('Variant introuvable'); if(btn){btn.disabled=false;btn.classList.remove('is-loading');} return; }
      
      function postOne(slotIdx) {
        var slot = s.slots[s.mix === 'mix' ? slotIdx : 0];
        var slotLabels = ['AV.G','AV.D','AR.G','AR.D'];
        var fd = new FormData();
        fd.append('id', vid);
        fd.append('quantity', '1');
        fd.append('properties[Slot]', slotLabels[slotIdx]);
        fd.append('properties[Design]', slot.mode === 'upload' ? 'Mon image perso' : 'Y2K Smile');
        fd.append('properties[Size]', s.size + '"');
        fd.append('properties[_Mode]', slot.mode);
        fd.append('properties[_SetId]', s.setId);
        fd.append('properties[_SetMode]', s.mix);
        if (slot.mode === 'upload') {
          fd.append('properties[_DesignFile]', file, file.name || 'logo.png');
          fd.append('properties[_ImgTransform]', 'zoom:'+slot.imgZoom+';rot:'+slot.imgRotate+';x:'+slot.imgX+';y:'+slot.imgY);
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          body: fd
        }).then(function(r){ return r.json(); });
      }
      
      var promise = Promise.resolve();
      for (var i=0; i<s.units; i++) {
        (function(idx){
          promise = promise.then(function(){ return postOne(idx); });
        })(i);
      }
      promise.then(function(){
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-success'); btn.innerHTML = 'AJOUTÉ ✓ Redirection…'; }
        setTimeout(function(){ window.location.href = '/cart'; }, 800);
      }).catch(function(err){
        console.error('WM upload submit error', err);
        alert('Erreur upload : ' + (err.message || err));
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      });
    }, true); // capture phase to intercept before original handler
  });
})();

;/* WM-FIX-2026-05-21-upload-trigger : rebranche le bouton parcourir (upload image) */
(function(){var r=document.querySelector('[data-wm-configurator]');if(!r)return;r.addEventListener('click',function(e){var z=e.target.closest('[data-wm-action="upload-trigger"]');if(!z)return;var i=z.querySelector('input[type="file"]');if(i)i.click();});})();
